/* eslint-disable no-unused-expressions */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { urlLoginEmpresas } from "../../../utils/constants";
import axiosClient from "../../../utils/axiosClient";
import {
  IonButton,
  IonInput,
  IonItem,
  IonLabel,
  IonText,
  IonCard,
  IonContent,
  IonActionSheet,
  IonToast,
} from "@ionic/react";

export default function LoginUsuario() {
  const navigate = useNavigate();
  const [codigo, setcodigo] = useState(55);
  const [ddd, setDDD] = useState("");
  const [numero, setNumero] = useState("");
  const [actionSheetNumero, setActionSheetNumero] = useState(false);

  const [colorToast, setColorToast] = useState("");
  const [iconToast, setIconToast] = useState("");
  const [mensagemToast, setMensagemToast] = useState("");
  const [tempoToast, setTempoToast] = useState("");
  const [textoToast, setTextoToast] = useState("");
  const [statusToast, setStatusToast] = useState(false);

  const fazerLogin = async () => {
    try {
      const response = await axiosClient.post(urlLoginEmpresas, {
        codigo: codigo,
        ddd: ddd,
        telefone: numero,
      });

      if (response.data.status == "1") {
        navigate({
          pathname: "/empresas/codigo_verificacao",
        });
      } else if (response.data.status == "2") {
        localStorage.setItem("codigo", codigo);
        localStorage.setItem("DDD", ddd);
        localStorage.setItem("numero", numero);
        navigate({
          pathname: "/empresas/cadastrar",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const verificarCampos = async () => {
    if (ddd.length < 2) {
      setColorToast("danger");
      setIconToast("alert-outline");
      setMensagemToast("Seu DDD precisa ter 2 dígitos");
      setTempoToast(10000);
      setTextoToast("Ok");
      setStatusToast(true);
      return;
    }

    if (ddd.length > 2) {
      setColorToast("danger");
      setIconToast("alert-outline");
      setMensagemToast("Seu DDD precisa ter 2 dígitos");
      setTempoToast(10000);
      setTextoToast("Ok");
      setStatusToast(true);
      return;
    }

    if (numero.length < 9) {
      setColorToast("danger");
      setIconToast("alert-outline");
      setMensagemToast("Seu número precisa ter 9 dígitos");
      setTempoToast(10000);
      setTextoToast("Ok");
      setStatusToast(true);
      return;
    }

    if (numero.length > 9) {
      setColorToast("danger");
      setIconToast("alert-outline");
      setMensagemToast("Seu número precisa ter 9 dígitos");
      setTempoToast(10000);
      setTextoToast("Ok");
      setStatusToast(true);
      return;
    }

    setActionSheetNumero(true);
  };

  const irParaCadastro = () => {
    navigate({
      pathname: "/usuarios/cadastrar",
    });
  };

  return (
    <IonContent>
      <div className="ion-margin">
        <div className="row">
          <div className="col-sm-4"></div>
          <div className="col-sm-4">
            <IonCard>
              <div className="ion-margin centro" name="logarusuario">
                <div style={{ margin: "1%" }}></div>

                <h2 className="nomeDoApp"></h2>

                <IonText color="medium">
                  <p className="IonText-center">
                    Preencha os campos abaixo para continuar
                  </p>
                </IonText>

                <IonItem>
                  <IonLabel position="stacked">Código do país: </IonLabel>
                  <IonInput
                    type="tel"
                    className="codigo"
                    maxlength={"5"}
                    minlength={"2"}
                    placeholder="Código do país"
                    onIonInput={(event) => {
                      event.preventDefault();
                      setcodigo(event.target.value);
                    }}
                    value={codigo}
                  />
                </IonItem>

                <IonItem>
                  <IonLabel position="stacked">DDD: </IonLabel>
                  <IonInput
                    type="tel"
                    maxlength={"2"}
                    minlength={"2"}
                    className="ddd"
                    placeholder="Digite seu DDD"
                    onIonInput={(event) => {
                      event.preventDefault();
                      setDDD(event.target.value);
                    }}
                    value={ddd}
                  />
                </IonItem>

                <IonItem>
                  <IonLabel position="stacked">Número: </IonLabel>
                  <IonInput
                    type="tel"
                    maxlength={"9"}
                    minlength={"9"}
                    className="numero"
                    placeholder="Digite seu número"
                    onIonInput={(event) => {
                      event.preventDefault();
                      setNumero(event.target.value);
                    }}
                    value={numero}
                  />
                </IonItem>

                <IonButton
                  color="secondary-light"
                  onClick={verificarCampos}
                  expand="full"
                  className="botaoLogar"
                >
                  Entrar &nbsp; <i className="ri-shield-check-line"></i>
                </IonButton>

            
              </div>
            </IonCard>
          </div>

          <div className="col-sm-4"></div>
        </div>
      </div>

      <IonActionSheet
        isOpen={actionSheetNumero}
        header={`O número +${codigo} ${ddd} ${numero} está correto?`}
        buttons={[
          {
            text: "Sim",
            role: "destructive",
            handler: () => fazerLogin(),
          },
          {
            text: "Fechar",
            role: "cancel",
            handler: () => {},
          },
        ]}
        onDidDismiss={() => setActionSheetNumero(false)}
      ></IonActionSheet>
      <IonToast
        isOpen={statusToast}
        color={colorToast}
        icon={iconToast}
        message={mensagemToast}
        onDidDismiss={() => setStatusToast(false)}
        duration={tempoToast}
        buttons={[
          {
            text: textoToast,
            role: "info",
            handler: () => {
              return;
            },
          },
        ]}
      ></IonToast>
    </IonContent>
  );
}
